import React from "react";

// Seasonal decoration behind the welcome page, picked by the race's theme (`decoration` in welcomeThemes.js).
// Add a new kind here (e.g. "flowers") and the welcome page itself doesn't change.
const DECORATIONS = {
  snow: { className: "rr-decor-snow", pieces: ["❄", "❅", "•", "❆", "•"] },
};

export default function WelcomeDecor({ type }) {
  const decoration = DECORATIONS[type];
  if (!decoration) return null;

  return (
    <div className={`rr-decor ${decoration.className}`} aria-hidden="true">
      {Array.from({ length: 40 }, (_, index) => (
        <span
          key={index}
          style={{
            left: `${(index * 37 + 7) % 100}%`,
            fontSize: `${10 + ((index * 7) % 14)}px`,
            animationDuration: `${9 + ((index * 5) % 8)}s`,
            animationDelay: `-${(index * 1.7) % 12}s`,
          }}
        >
          {decoration.pieces[index % decoration.pieces.length]}
        </span>
      ))}
    </div>
  );
}
